/**
 * @generated SignedSource<<3d3f1ded67f01b46b2b92185c1c785c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CMSENUM_COMPONENTSHAREDMETASOCIAL_SOCIALNETWORK = "Facebook" | "Twitter" | "%future added value";
export type ArticlePageQuery$variables = {
  articleSlug?: string | null;
};
export type ArticlePageQuery$data = {
  readonly cmsArticles: {
    readonly data: ReadonlyArray<{
      readonly attributes: {
        readonly slug: string | null;
        readonly title: string | null;
        readonly description: string;
        readonly seo: {
          readonly keywords: string | null;
          readonly metaTitle: string;
          readonly metaViewport: string | null;
          readonly metaDescription: string;
          readonly canonicalURL: string | null;
          readonly metaRobots: string | null;
          readonly metaImage: {
            readonly data: {
              readonly attributes: {
                readonly url: string;
              } | null;
            } | null;
          } | null;
          readonly metaSocial: ReadonlyArray<{
            readonly socialNetwork: CMSENUM_COMPONENTSHAREDMETASOCIAL_SOCIALNETWORK;
            readonly title: string;
            readonly description: string;
            readonly image: {
              readonly data: {
                readonly attributes: {
                  readonly url: string;
                } | null;
              } | null;
            } | null;
          } | null> | null;
          readonly structuredData: any | null;
        } | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"ArticleFragment">;
    }>;
  } | null;
};
export type ArticlePageQuery = {
  variables: ArticlePageQuery$variables;
  response: ArticlePageQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "articleSlug"
  }
],
v1 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "eq",
            "variableName": "articleSlug"
          }
        ],
        "kind": "ObjectValue",
        "name": "slug"
      }
    ],
    "kind": "ObjectValue",
    "name": "filters"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "keywords",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaTitle",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaViewport",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaDescription",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canonicalURL",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metaRobots",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "CMSUploadFile",
  "kind": "LinkedField",
  "name": "attributes",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CMSUploadFileEntity",
    "kind": "LinkedField",
    "name": "data",
    "plural": false,
    "selections": [
      (v12/*: any*/)
    ],
    "storageKey": null
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialNetwork",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "structuredData",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v17 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CMSUploadFileEntity",
    "kind": "LinkedField",
    "name": "data",
    "plural": false,
    "selections": [
      (v12/*: any*/),
      (v16/*: any*/)
    ],
    "storageKey": null
  }
],
v18 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CMSUploadFileEntity",
    "kind": "LinkedField",
    "name": "data",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CMSUploadFile",
        "kind": "LinkedField",
        "name": "attributes",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "alternativeText",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v16/*: any*/)
    ],
    "storageKey": null
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "CMSComponentSharedSvojstvaSekczii",
  "kind": "LinkedField",
  "name": "sectionProperties",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CMSUploadFileEntityResponse",
      "kind": "LinkedField",
      "name": "backgroundImage",
      "plural": false,
      "selections": (v17/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentMaximumWidth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topPadding",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bottomPadding",
      "storageKey": null
    },
    (v16/*: any*/)
  ],
  "storageKey": null
},
v21 = [
  (v19/*: any*/),
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ArticlePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CMSArticleEntityResponseCollection",
        "kind": "LinkedField",
        "name": "cmsArticles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CMSArticleEntity",
            "kind": "LinkedField",
            "name": "data",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CMSArticle",
                "kind": "LinkedField",
                "name": "attributes",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CMSComponentSharedSeo",
                    "kind": "LinkedField",
                    "name": "seo",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CMSUploadFileEntityResponse",
                        "kind": "LinkedField",
                        "name": "metaImage",
                        "plural": false,
                        "selections": (v13/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CMSComponentSharedMetaSocial",
                        "kind": "LinkedField",
                        "name": "metaSocial",
                        "plural": true,
                        "selections": [
                          (v14/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CMSUploadFileEntityResponse",
                            "kind": "LinkedField",
                            "name": "image",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ArticleFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ArticlePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CMSArticleEntityResponseCollection",
        "kind": "LinkedField",
        "name": "cmsArticles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CMSArticleEntity",
            "kind": "LinkedField",
            "name": "data",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CMSArticle",
                "kind": "LinkedField",
                "name": "attributes",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CMSComponentSharedSeo",
                    "kind": "LinkedField",
                    "name": "seo",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CMSUploadFileEntityResponse",
                        "kind": "LinkedField",
                        "name": "metaImage",
                        "plural": false,
                        "selections": (v17/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CMSComponentSharedMetaSocial",
                        "kind": "LinkedField",
                        "name": "metaSocial",
                        "plural": true,
                        "selections": [
                          (v14/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CMSUploadFileEntityResponse",
                            "kind": "LinkedField",
                            "name": "image",
                            "plural": false,
                            "selections": (v17/*: any*/),
                            "storageKey": null
                          },
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CMSUploadFileEntityResponse",
                    "kind": "LinkedField",
                    "name": "cover",
                    "plural": false,
                    "selections": (v18/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publishedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "blocks",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v16/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/)
                        ],
                        "type": "CMSComponentSharedRichText",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CMSComponentSharedDecoratedListItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CMSComponentSharedMedia",
                                "kind": "LinkedField",
                                "name": "image",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CMSUploadFileEntityResponse",
                                    "kind": "LinkedField",
                                    "name": "file",
                                    "plural": false,
                                    "selections": (v18/*: any*/),
                                    "storageKey": null
                                  },
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CMSComponentSharedRichText",
                                "kind": "LinkedField",
                                "name": "primaryText",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CMSComponentSharedRichText",
                                "kind": "LinkedField",
                                "name": "secondaryText",
                                "plural": false,
                                "selections": (v21/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v20/*: any*/)
                        ],
                        "type": "CMSComponentSharedDecoratedList",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v16/*: any*/),
                          (v20/*: any*/)
                        ],
                        "type": "CMSComponentSharedShowMore",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rotate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "interval",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CMSComponentElementsKarusel",
                            "kind": "LinkedField",
                            "name": "carouselItems",
                            "plural": true,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CMSUploadFileEntityResponse",
                                "kind": "LinkedField",
                                "name": "image",
                                "plural": false,
                                "selections": (v18/*: any*/),
                                "storageKey": null
                              },
                              (v19/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v20/*: any*/)
                        ],
                        "type": "CMSComponentSharedKarusel",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rootCategory",
                            "storageKey": null
                          },
                          (v20/*: any*/)
                        ],
                        "type": "CMSComponentSharedMagazinKatalog",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "categorySlug",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "numProducts",
                            "storageKey": null
                          },
                          (v20/*: any*/)
                        ],
                        "type": "CMSComponentSharedMagazinTovary",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CMSComponentLinksButtonLink",
                            "kind": "LinkedField",
                            "name": "buttons",
                            "plural": true,
                            "selections": [
                              (v16/*: any*/),
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "text",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "type",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "newTab",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v20/*: any*/)
                        ],
                        "type": "CMSComponentSharedButtonBar",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2ae398cb0ce0ab57329f636710d99bbe",
    "id": null,
    "metadata": {},
    "name": "ArticlePageQuery",
    "operationKind": "query",
    "text": "query ArticlePageQuery(\n  $articleSlug: String\n) {\n  cmsArticles(filters: {slug: {eq: $articleSlug}}) {\n    data {\n      attributes {\n        slug\n        title\n        description\n        seo {\n          keywords\n          metaTitle\n          metaViewport\n          metaDescription\n          canonicalURL\n          metaRobots\n          metaImage {\n            data {\n              attributes {\n                url\n              }\n              id\n            }\n          }\n          metaSocial {\n            socialNetwork\n            title\n            description\n            image {\n              data {\n                attributes {\n                  url\n                }\n                id\n              }\n            }\n            id\n          }\n          structuredData\n          id\n        }\n      }\n      ...ArticleFragment\n      id\n    }\n  }\n}\n\nfragment ArticleFragment on CMSArticleEntity {\n  id\n  attributes {\n    slug\n    title\n    description\n    cover {\n      data {\n        attributes {\n          url\n          alternativeText\n        }\n        id\n      }\n    }\n    publishedAt\n    blocks {\n      __typename\n      ... on CMSComponentSharedRichText {\n        id\n        body\n        sectionProperties {\n          backgroundColor\n          backgroundImage {\n            data {\n              attributes {\n                url\n              }\n              id\n            }\n          }\n          contentMaximumWidth\n          topPadding\n          bottomPadding\n          id\n        }\n      }\n      ... on CMSComponentSharedDecoratedList {\n        id\n        items {\n          id\n          image {\n            file {\n              data {\n                attributes {\n                  url\n                  alternativeText\n                }\n                id\n              }\n            }\n            id\n          }\n          primaryText {\n            body\n            id\n          }\n          secondaryText {\n            body\n            id\n          }\n        }\n        sectionProperties {\n          backgroundColor\n          backgroundImage {\n            data {\n              attributes {\n                url\n              }\n              id\n            }\n          }\n          contentMaximumWidth\n          topPadding\n          bottomPadding\n          id\n        }\n      }\n      ... on CMSComponentSharedShowMore {\n        id\n        sectionProperties {\n          backgroundColor\n          backgroundImage {\n            data {\n              attributes {\n                url\n              }\n              id\n            }\n          }\n          contentMaximumWidth\n          topPadding\n          bottomPadding\n          id\n        }\n      }\n      ... on CMSComponentSharedKarusel {\n        id\n        rotate\n        interval\n        carouselItems {\n          id\n          image {\n            data {\n              attributes {\n                url\n                alternativeText\n              }\n              id\n            }\n          }\n          body\n        }\n        sectionProperties {\n          backgroundColor\n          backgroundImage {\n            data {\n              attributes {\n                url\n              }\n              id\n            }\n          }\n          contentMaximumWidth\n          topPadding\n          bottomPadding\n          id\n        }\n      }\n      ... on CMSComponentSharedMagazinKatalog {\n        id\n        rootCategory\n        sectionProperties {\n          backgroundColor\n          backgroundImage {\n            data {\n              attributes {\n                url\n              }\n              id\n            }\n          }\n          contentMaximumWidth\n          topPadding\n          bottomPadding\n          id\n        }\n      }\n      ... on CMSComponentSharedMagazinTovary {\n        id\n        categorySlug\n        numProducts\n        sectionProperties {\n          backgroundColor\n          backgroundImage {\n            data {\n              attributes {\n                url\n              }\n              id\n            }\n          }\n          contentMaximumWidth\n          topPadding\n          bottomPadding\n          id\n        }\n      }\n      ... on CMSComponentSharedButtonBar {\n        id\n        buttons {\n          id\n          url\n          text\n          type\n          newTab\n        }\n        sectionProperties {\n          backgroundColor\n          backgroundImage {\n            data {\n              attributes {\n                url\n              }\n              id\n            }\n          }\n          contentMaximumWidth\n          topPadding\n          bottomPadding\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f3b6b3670832d645d40395f1ceda783a";

export default node;
